export default { sha: '398e72c6f76cafbf6d7df8a38991b8b6b9135040', buildNumber: 'undefined' }
